module.exports = __webpack_public_path__ + "static/media/healthy.be8d5281.png";